import { Textarea as FlowbiteTextarea } from 'flowbite-react';

export interface TextareaProps {
  label?: string;
  placeholder?: string;
  value?: string;
  onChange?: (value: string) => void;
  disabled?: boolean;
  rows?: number;
  required?: boolean;
  error?: string;
  noResize?: boolean;
}

export const Textarea: React.FC<TextareaProps> = ({
  label,
  placeholder,
  value,
  onChange,
  disabled = false,
  rows = 4,
  required = false,
  error,
  noResize,
}) => {
  return (
    <div className="flex flex-col gap-2 w-full">
      {label && (
        <label className="text-sm font-medium text-gray-900">
          {label}
          {required && <span className="text-red-600 ml-1">*</span>}
        </label>
      )}
      <FlowbiteTextarea
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
        disabled={disabled}
        rows={rows}
        className={`w-full ${noResize && 'resize-none'}`}
      />
      {error && <p className="text-sm text-red-600">{error}</p>}
    </div>
  );
};
